var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("cell-group", { attrs: { list: _vm.settingList } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }